/**
 * Тег «почему изменился store» для отладки FILEATTACHMENTS (`debug_attachment_tape=1`).
 * Писатель вызывает `mark…` непосредственно перед мутацией registry; watch `model-value` — `pull…`.
 */
export type AttachmentStoreMutationCause =
  | 'register-element'
  | 'page-field-sync'
  | 'setValue'
  | 'setValue-skipped-empty'
  | 'states-refill'
  | 'states-empty'
  | 'gp-refill'
  | 'gp-refill-skipped'
  | 'element-refill'
  | 'selection-reload'
  | 'element-reload'
  | 'user-input'
  | 'upload-merge'
  | 'download-meta-merge'
  | 'resync-tab-slot'
  | 'element-empty'
  | 'unknown'

type PendingCause = {
  cause: AttachmentStoreMutationCause
  detail?: Record<string, unknown>
  at: number
}

const pendingBySlot = new Map<string, PendingCause>()

const CAUSE_TTL_MS = 3000

function slotKey(fieldName: string, elementId: string | number | null | undefined): string {
  const fid = String(fieldName ?? '').trim()
  const eid = String(elementId ?? '').trim()
  if (!fid) return ''
  return eid ? `${eid}:${fid}` : fid
}

export function markAttachmentStoreMutationCause(options: {
  fieldName: string
  elementId?: string | number | null
  cause: AttachmentStoreMutationCause
  detail?: Record<string, unknown>
}): void {
  const key = slotKey(options.fieldName, options.elementId)
  if (!key) return
  pendingBySlot.set(key, {
    cause: options.cause,
    detail: options.detail,
    at: Date.now(),
  })
}

export function pullAttachmentStoreMutationCause(
  fieldName: string,
  elementId?: string | number | null,
): { cause: AttachmentStoreMutationCause; detail?: Record<string, unknown> } | null {
  const key = slotKey(fieldName, elementId)
  if (!key) return null
  const entry = pendingBySlot.get(key)
  if (!entry) return null
  pendingBySlot.delete(key)
  const stale = Date.now() - entry.at > CAUSE_TTL_MS
  return {
    cause: entry.cause,
    detail: stale ? { ...entry.detail, causeStale: true } : entry.detail,
  }
}

export function peekAttachmentStoreMutationCause(
  fieldName: string,
  elementId?: string | number | null,
): { cause: AttachmentStoreMutationCause; detail?: Record<string, unknown> } | null {
  const key = slotKey(fieldName, elementId)
  if (!key) return null
  const entry = pendingBySlot.get(key)
  if (!entry) return null
  return { cause: entry.cause, detail: entry.detail }
}
